import styles from './AirspaceRow.module.css';

import React, { Component } from 'react';

import {TableRow, TableCell}  from '@material-ui/core';
import Airspaces from '../../../tools/Airspaces';
import AirspaceLayer from '../../../GoogleMaps/AirspaceLayer';


export default class AirspaceRow extends Component {

    getBackgroundColor() {
        const {airspace} = this.props;
        return AirspaceLayer.getAirspaceColor(airspace);
    }

    getAirspaceClass() {
        const {airspace} = this.props;
        return AirspaceLayer.getAirspaceClassShort(airspace);
    }

    render() {
        const {airspace} = this.props;

        return (
            <TableRow>
                <TableCell><div style={{backgroundColor:this.getBackgroundColor()}} className={styles.class}>{this.getAirspaceClass()}</div></TableCell>
                <TableCell>{airspace.name}</TableCell>

                <TableCell>
                    <div className={styles.content}>
                        <div>{Airspaces.getReadableLimit(airspace.upperLimit)}</div>
                        <div className={styles.line}></div>
                        <div>{Airspaces.getReadableLimit(airspace.lowerLimit)}</div>
                    </div>
                 </TableCell>
           
            </TableRow>
        )
    }
}